import Vue from 'vue';

export default Vue.extend({
  data() {
    return { tab: null as number | null };
  },
  beforeRouteLeave(to, _from, next) {
    if (to.meta.fromHistory && this.tab !== 0) {
      this.tab = 0;

      next(false);
    } else {
      next();
    }
  },
});
